import AnalysisTypeComponent from './AnalysisType'
import AssetClassComponent from './AssetClass'
import BSUOPComponent from './Bsuop'
import ConditionFactorsComponent from './ConditionFactors'
import ConstructionQualityFactorComponent from './ConstructionQualityFactor'
import ContractComponent from './Contract'
import GroupingBankComponent from './GroupingBank'
import HistoricalCostIndexComponent from './HistoricalCostIndex'
import LocationFactorComponent from './LocationFactor'
import PropertySubTypeComponent from './PropertySubType'
import PropertyTypeComponent from './PropertyType'
import PropertyUnitsComponent from './PropertyUnits'
import TakeOffComponent from './TakeOff'
import TenantBankComponent from './TenantBank'
import UnitComponent from './Unit'
import ProjectUnitComponent from './Project/Unit'
import ProjectBSUOPComponent from './Project/Bsuop'
import ProjectAssetClassComponent from './Project/AssetClass'
import ProjectContractComponent from './Project/Contract'
import ProjectCategoryCodeComponent from './Project/CategoryCode'
import ProjectTakeoffComponent from './Project/Takeoff'
import TenantTypeComponent from './TenantType'
import DepreciationComponent from './DepreciationSchedule'
import { instance, errorService } from '@/services/api'
import { masterAPIs } from '@/services/authConstantsV1'

export default {
  components: {
    AnalysisTypeComponent,
    AssetClassComponent,
    BSUOPComponent,
    ConditionFactorsComponent,
    ConstructionQualityFactorComponent,
    ContractComponent,
    GroupingBankComponent,
    HistoricalCostIndexComponent,
    LocationFactorComponent,
    PropertySubTypeComponent,
    PropertyTypeComponent,
    PropertyUnitsComponent,
    TakeOffComponent,
    TenantBankComponent,
    UnitComponent,
    ProjectUnitComponent,
    ProjectBSUOPComponent,
    ProjectAssetClassComponent,
    ProjectContractComponent,
    ProjectCategoryCodeComponent,
    ProjectTakeoffComponent,
    TenantTypeComponent,
    DepreciationComponent,
  },
  props: {
    isHide: Boolean,
    type: String,
    keyId: String,
    columnSettings: Array,
    projectData: Object,
  },
  data: function() {
    return {
      tabKey: null,
      tabList: [
        {
          key: 1,
          tab: 'Analysis Type',
          type: 'analysis-type',
        },
        {
          key: 2,
          tab: 'Structure Profile',
          type: 'structure-profile',
        },
        {
          key: 3,
          tab: 'Building Use',
          type: 'building-use',
        },
        {
          key: 16,
          tab: 'Tenant Type',
          type: 'tenant-type',
        },
        {
          key: 4,
          tab: 'Construction Quality Factor',
          type: 'construction-quality-factor',
        },
        {
          key: 5,
          tab: 'Condition Factor',
          type: 'condition-factor',
        },
        {
          key: 6,
          tab: 'Unit',
          type: 'unit',
        },
        {
          key: 12,
          tab: 'BSUOP',
          type: 'bsuop',
        },
        {
          key: 7,
          tab: 'Asset Class',
          type: 'asset-class',
        },
        {
          key: 14,
          tab: 'Contract',
          type: 'contract',
        },
        {
          key: 8,
          tab: 'Category Code',
          type: 'category-code',
        },
        {
          key: 9,
          tab: 'Takeoff',
          type: 'takeoff',
        },
        {
          key: 10,
          tab: 'Grouping Bank',
          type: 'grouping-bank',
        },
        {
          key: 11,
          tab: 'Tenant Bank',
          type: 'tenant-bank',
        },
        {
          key: 13,
          tab: 'Historical Cost Index',
          type: 'historical-cost-index',
        },
        {
          key: 15,
          tab: 'Location Factor',
          type: 'location-factor',
        },
        {
          key: 17,
          tab: 'Depreciation Table',
          type: 'depreciation-schedule',
        },
      ],
      defaultActiveKey: this.isHide ? '6' : '1',
      tabId: this.isHide ? 'Unit' : 'Analysis Type',
      activeKey: this.isHide ? '6' : '1',
      role: undefined,
      isArchive: false,
    }
  },
  mounted() {
    this.$root.$on('updateColumn', this.updateColumns)
  },
  beforeDestroy() {
    this.$root.$off('updateColumn')
  },
  created() {
    if (!this.$route.meta.title) {
      this.$router.push('/master/analysis-type')
    } else {
      if (!this.isHide) {
        const type = this.tabList.find(i => i.type === this.$route.meta.type)
        this.defaultActiveKey = String(type.key)
        this.activeKey = String(type.key)
        this.tabId = type.tab
      }
    }
    const user = JSON.parse(localStorage.getItem('userDetails'))
    if (user) {
      this.role = user.role
    }

    if (this.projectData) {
      this.isArchive = this.projectData.isArchive
      if (!this.isArchive) {
        this.isArchive = this.projectData.archiveStatus === 'QUEUED'
      }
    }
  },
  watch: {
    keyId() {
      if (
        this.keyId === '2' &&
        (this.type === 'Template' || this.type === 'Project')
      ) {
        this.tabKey = '6'
        this.activeKey = '6'
      } else {
        this.tabKey = null
        this.activeKey = null
      }
    },
  },
  methods: {
    tabClick(key) {
      this.tabKey = key
      this.activeKey = key
      const type = this.tabList.find(i => i.key === Number(key))
      this.tabId = type.tab
      if (!this.isHide) {
        this.$router.push(`${type.type}`)
      }
    },

    onChange(value) {
      this.tabClick(String(this.tabList.find(i => i.tab === value).key))
    },

    updateColumnSettings(request) {
      if (!this.isArchive) {
        this.$emit('updateColumnSettings', request)
      }
    },

    updateColumns(request) {
      if (!this.isArchive) {
        const url = masterAPIs.columnSetting.update(request.type)
        instance
          .patch(url, request)
          .then(response => {})
          .catch(error => {
            this.loading = false
            errorService(error)
          })
      }
    },
  },
}
